<template>
  <div class="create-exam">
    <div class="create-exam-header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/examManage/create' }"
          >考试管理</el-breadcrumb-item
        >
        <el-breadcrumb-item>创建考试</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="exam-hr" style="margin-top: 26px"></div>
    <!-- 主体 -->
    <div class="exam-main">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <div class="exam-title">
          <div class="green-block"></div>
          <span>考场设置</span>
        </div>
        <!-- 考场设置 -->
        <div class="exam-setting">
          <el-form-item
            label="考试名称"
            prop="examName"
            style="margin-left: 1px; width: 446px"
          >
            <el-input
              v-model="ruleForm.examName"
              placeholder="考试名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="选择考场" prop="examRoom">
            <el-select
              v-model="ruleForm.examRoom"
              placeholder="请选择考场"
              style="width: 347px"
            >
              <el-option
                v-for="item in examRoomList"
                :key="item.id"
                :label="item.examination_room_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 考试时间 -->
          <div class="exam-time">
            <el-form-item
              label="开始时间"
              style="margin-left: 1px; width: 446px"
            >
              <el-date-picker
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="选择开始时间"
                style="width: 346px"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item
              label="结束时间"
              style="margin-left: 1px; width: 446px"
            >
              <el-date-picker
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="选择结束时间"
                style="width: 346px"
              >
              </el-date-picker>
            </el-form-item>
          </div>
        </div>
        <!-- 选择考生 -->
        <div class="exam-title">
          <div class="green-block"></div>
          <span>选择考生</span>
          <div class="change-btn">
            <el-button type="primary" @click="changeStudent"
              >选择学生</el-button
            >
          </div>
        </div>
        <!-- 选择考生表格 -->
        <div class="change-student">
          <el-table
            class="customTable"
            :data="studentList"
            style="margin-top: 20px; flex: 1"
            size="medium"
            max-height="480px"
            :header-cell-style="{
              fontWeight: 'normal',
              height: '60px',
              color: '#666666',
              background: '#F6F6F6',
              fontSize: '16px',
            }"
            :cell-style="{ fontSize: '16px', color: '#333333', height: '70px' }"
          >
            <el-table-column prop="sid" label="序号"> </el-table-column>
            <el-table-column prop="name" label="学生姓名"> </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-link
                  type="danger"
                  :underline="false"
                  @click="deleteStudentItem(scope.row)"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            class="pager-center"
            style="margin: 20px 0 30px; text-align: center"
            :current-page="Pages.currentPageNum"
            :page-size="Pages.eachPageNum"
            :total="Pages.total"
            layout="prev, pager, next, jumper"
            @current-change="CurrentChange"
          >
          </el-pagination> -->
        </div>
        <!-- 选择考生会话框 -->
        <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="studentTitle"
          custom-class="green-dialog"
          :visible.sync="studentDialogVisible"
          width="500px"
          @opened="selectStudentList"
        >
          <span style="margin-right: 15px">学生分类</span>
          <el-select
            v-model="studentSelect"
            placeholder="请选择考试场次"
            @change="selectStudentList"
          >
            <el-option
              v-for="item in studentCategoryList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <div class="student-table">
            <el-checkbox-group
              v-model="studentChecked"
              v-for="(item, index) in studentTable"
              :key="index"
            >
              <el-checkbox :label="item.user_id" class="student-check">{{
                item.nickname
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="dialog-footer" style="margin-top: 20px">
            <el-button @click="studentDialogVisible = false">取 消</el-button>
            <el-button
              style="margin-left: 30px"
              type="primary"
              @click="studentConfirmForm"
              >确 定</el-button
            >
          </div>
        </el-dialog>

        <!-- 选择试卷 -->
        <div class="exam-title" style="margin-top: 44px">
          <div class="green-block"></div>
          <span>选择试卷</span>
          <div class="change-btn">
            <el-button type="primary" @click="changePapers">选择试卷</el-button>
          </div>
        </div>
        <!-- 选择试卷表格 -->
        <div class="change-paper">
          <el-table
            class="customTable"
            :data="paperList"
            style="margin-top: 20px; flex: 1"
            size="medium"
            :header-cell-style="{
              fontWeight: 'normal',
              height: '60px',
              color: '#666666',
              background: '#F6F6F6',
              fontSize: '16px',
            }"
            :cell-style="{ fontSize: '16px', color: '#333333', height: '70px' }"
          >
            <el-table-column prop="pid" label="序号" width="540">
            </el-table-column>
            <el-table-column prop="name" label="试卷名称"> </el-table-column>
          </el-table>
        </div>
        <!-- <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="paperTitle"
          custom-class="green-dialog"
          :visible.sync="paperDialogVisible"
          width="500px"
        >
          <span>试卷类型</span>
          <el-radio-group v-model="paperRadio" style="margin-left: 10px">
            <el-radio :label="1">理论题</el-radio>
            <el-radio :label="2">实操题</el-radio>
            <el-radio :label="3">理论题 + 实操题</el-radio>
          </el-radio-group>
          <div class="paper-select">
            <span style="line-height: 40px">随机试卷</span>
            <el-select
              v-model="paperValue"
              multiple
              collapse-tags
              style="margin-left: 20px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
          </div>
          <div class="dialog-footer" style="margin-top: 20px">
            <el-button @click="paperDialogVisible = false">取 消</el-button>
            <el-button
              style="margin-left: 30px"
              type="primary"
              @click="paperConfirmForm"
              >确 定</el-button
            >
          </div>
        </el-dialog> -->
        <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="paperTitle"
          custom-class="green-dialog"
          :visible.sync="paperDialogVisible"
          width="70%"
        >
          <!-- 试卷类型 -->
          <div class="paper-category" style="display: flex">
            <span style="margin-right: 15px; line-height: 40px">考试类型</span>
            <el-select v-model="paperValue" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 考试形式 -->
          <div class="paper-item">
            <span style="margin-right: 15px; line-height: 40px">考试形式</span>
            <el-select v-model="paperCategory" placeholder="请选择">
              <el-option
                v-for="item in paperOptions"
                :key="item.value"
                :label="item.label"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 考试试卷 -->
          <div class="paper-exam" style="margin: 25px 0 20px 0">
            <span style="margin-right: 15px; line-height: 40px">考试试卷</span>
            <el-radio-group v-model="paperRadioItem">
              <el-radio :label="1">选择试卷考试</el-radio>
              <el-select
                v-model="paperExam"
                placeholder="请选择"
                :disabled="paperRadioItem != 1"
              >
                <el-option
                  v-for="item in changePaper"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <el-radio :label="2" style="display: flex; margin-top: 15px"
                >题库随机组卷(题数100题)</el-radio
              >
            </el-radio-group>
          </div>
          <!-- 选择理论考试显示 -->
          <!--   <div
            class="paper-table"
            v-if="paperCategory == 1 && paperRadioItem == 2"
          >
            <div class="exam-title" style="margin: 24px 0 30px 20px">
              <div class="green-block"></div>
              <span>题库随机组卷</span>
            </div>
            <span style="margin-left: 20px">题型数设置</span>
            
            <div class="question-setting">
              <span style="margin-right: 5px; line-height: 40px">单选题</span>
              <el-input
                v-model="singleQuestions"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">题</span>
              <el-input
                v-model="singleQuestionsScore"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">题/分</span>
             
              <span style="margin: 0 5px 0 79px; line-height: 40px"
                >多选题</span
              >
              <el-input
                v-model="multipleQuestions"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">题</span>
              <el-input
                v-model="multipleQuestionsScore"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin-left: 5px; line-height: 40px">题/分</span>
             
              <span style="margin: 0 5px 0 79px; line-height: 40px"
                >判断题</span
              >
              <el-input
                v-model="judgmentQuestion"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">题</span>
              <el-input
                v-model="judgmentQuestionScore"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin-left: 5px; line-height: 40px">题/分</span>
            </div>
           
            <div class="scope-question">
              <span style="margin-left: 20px">鉴定范围题数设置</span>
              <table border="0" width="70%" class="scope-table">
                <tbody class="scope-table-header">
                  <tr>
                    <th style="height: 40px" rowspan="1" colspan="3">
                      鉴定范围
                    </th>
                  </tr>
                  <tr>
                    <td rowspan="1" colspan="2">一级</td>
                    <td rowspan="1" colspan="2">二级</td>
                    <td rowspan="1" colspan="2">三级</td>
                    <td width="139" rowspan="2">题数</td>
                  </tr>
                  <tr>
                    <td>代码</td>
                    <td>名称</td>
                    <td>代码</td>
                    <td>名称</td>
                    <td>代码</td>
                    <td>名称</td>
                  </tr>
                </tbody>
              </table>
              <div class="table-box">
                <div class="table-left-1">A</div>
                <div class="table-left-2">基本要求</div>
                <div class="table-left-3">A</div>
                <div class="table-left-4">职业道德</div>
                <div class="table-left-5">B</div>
                <div class="table-left-6">基础知识</div>
                <div class="table-left-7">A</div>
                <div class="table-left-8">职业道德</div>
                <div class="table-left-9">B</div>
                <div class="table-left-10">基础知识</div>
                <div class="table-right-1">A</div>
                <div class="table-right-2">职业道德</div>
                <div class="table-right-3">B</div>
                <div class="table-right-4">基础知识</div>
                <div class="table-right-5">
                  <el-input style="width: 45px"></el-input>
                </div>
                <div class="table-right-6">
                  <el-input style="width: 45px"></el-input>
                </div>
                <div class="table-right-7">
                  <el-input style="width: 45px"></el-input>
                </div>
                <div class="table-right-8">
                  <el-input style="width: 45px"></el-input>
                </div>
              </div>
              <span style="margin-left: 20px">题库随机规则</span>
              <div class="question-level">
                <span style="line-height: 40px">难度系数 （1-5）</span>
                <el-input v-model="questionLow" style="width: 45px"></el-input>
                <span style="line-height: 40px; margin: 0 10px">~</span>
                <el-input v-model="questionHigh" style="width: 45px"></el-input>
              </div>
              <div class="question-type">
                <span style="margin-right: 10px">每个鉴定点题型不同</span>
                <el-radio-group v-model="questionType">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="2">否</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div> -->
          <!-- 选择实操考试显示 -->
          <!--  <div
            class="paper-table"
            v-if="paperCategory == 2 && paperRadioItem == 2"
          >
            <div class="exam-title" style="margin: 24px 0 30px 20px">
              <div class="green-block"></div>
              <span>题库随机组卷</span>
            </div>
            <span style="margin-left: 20px">题型数设置</span>
     
            <div class="question-setting">
             
              <span style="margin-right: 5px; line-height: 40px"
                >商品信息采处理</span
              >
              <el-input
                v-model="operationOne"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">分</span>

              
              <span style="margin: 0 5px 0 79px; line-height: 40px"
                >网店开设</span
              >
              <el-input
                v-model="operationTwo"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">分</span>

              
              <span style="margin: 0 5px 0 79px; line-height: 40px"
                >网店管理</span
              >
              <el-input
                v-model="operationThree"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">分</span>

              <span style="margin: 0 5px 0 79px; line-height: 40px"
                >网店推广</span
              >
              <el-input
                v-model="operationFour"
                onkeyup="value=value.replace(/[^\d]/g,'')"
                style="width: 40px"
              ></el-input>
              <span style="margin: 0 5px 0 5px; line-height: 40px">分</span>
            </div>
            <div class="scope-question">
              <span style="margin-left: 20px">鉴定范围题数设置</span>
              <table border="0" width="30%" class="scope-table">
                <tbody class="scope-table-header">
                  <tr>
                    <th style="height: 40px" rowspan="1" colspan="3">
                      鉴定范围
                    </th>
                  </tr>
                  <tr>
                    <td rowspan="1" colspan="2">一级</td>
                    <td width="139" rowspan="2">题数</td>
                  </tr>
                  <tr>
                    <td rowspan="1">代码</td>
                    <td rowspan="1">名称</td>
                  </tr>
                  <tr>
                    <td colspan="1" style="height: 80px">A</td>
                    <td colspan="1" style="height: 80px">商品信息 采集处理</td>
                    <td colspan="1" style="height: 80px">
                      <el-input style="width: 45px"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1" style="height: 80px">B</td>
                    <td colspan="1" style="height: 80px">网店开设</td>
                    <td colspan="1" style="height: 80px">
                      <el-input style="width: 45px"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1" style="height: 80px">C</td>
                    <td colspan="1" style="height: 80px">网店管理</td>
                    <td colspan="1" style="height: 80px">
                      <el-input style="width: 45px"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1" style="height: 80px">D</td>
                    <td colspan="1" style="height: 80px">网店推广</td>
                    <td colspan="1" style="height: 80px">
                      <el-input style="width: 45px"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1" style="height: 80px">E</td>
                    <td colspan="1" style="height: 80px">客户管理服务</td>
                    <td colspan="1" style="height: 80px">
                      <el-input style="width: 45px"></el-input>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="1" style="height: 80px">F</td>
                    <td colspan="1" style="height: 80px">数据分析应用</td>
                    <td colspan="1" style="height: 80px">
                      <el-input style="width: 45px"></el-input>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <span style="margin-left: 20px">题库随机规则</span>
            <div class="question-level">
              <span style="line-height: 40px">难度系数 （1-5）</span>
              <el-input v-model="questionLow" style="width: 45px"></el-input>
              <span style="line-height: 40px; margin: 0 10px">~</span>
              <el-input v-model="questionHigh" style="width: 45px"></el-input>
            </div>
            <div class="question-type">
              <span style="margin-right: 10px">每个鉴定点题型不同</span>
              <el-radio-group v-model="questionType">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </div>
          </div> -->
          <div class="dialog-footer" style="margin-top: 20px">
            <el-button @click="paperDialogVisible = false">取 消</el-button>
            <el-button
              style="margin-left: 30px"
              type="primary"
              @click="paperconfirmForm"
              >确定</el-button
            >
          </div>
        </el-dialog>
        <!-- 选择评委 -->
        <div class="exam-title" style="margin-top: 44px">
          <div class="green-block"></div>
          <span>选择评委</span>
          <div class="change-btn">
            <el-button type="primary" @click="changeJudge">选择评委</el-button>
          </div>
        </div>
        <!-- 选择评委表格 -->
        <div class="change-judge">
          <el-table
            class="customTable"
            :data="judgeList"
            style="margin-top: 20px; flex: 1"
            size="medium"
            :header-cell-style="{
              fontWeight: 'normal',
              height: '60px',
              color: '#666666',
              background: '#F6F6F6',
              fontSize: '16px',
            }"
            :cell-style="{ fontSize: '16px', color: '#333333', height: '70px' }"
          >
            <el-table-column prop="jid" label="序号"> </el-table-column>
            <el-table-column prop="name" label="评委名称"> </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-link
                  type="danger"
                  :underline="false"
                  @click="deleteJudgeItem(scope.row)"
                  >删除</el-link
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :title="judgeTitle"
          custom-class="green-dialog"
          :visible.sync="judgeDialogVisible"
          width="500px"
        >
          <div class="student-table">
            <el-checkbox-group
              v-model="judgeChecked"
              v-for="(item, index) in judgeTable"
              :key="index"
            >
              <el-checkbox :label="item.id" class="student-check">{{
                item.nickname
              }}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="dialog-footer" style="margin-top: 20px">
            <el-button @click="judgeDialogVisible = false">取 消</el-button>
            <el-button
              style="margin-left: 30px"
              type="primary"
              @click="judgeConfirmForm"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      </el-form>
      <div class="dialog-footer" style="margin-top: 20px">
        <el-button @click="cancelExam">取 消</el-button>
        <el-button
          style="margin-left: 30px"
          type="primary"
          @click="confirmForm('ruleForm')"
          >保 存</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  showExaminatinRoom,
  examStudentList,
  showExamStudentList,
  showExamJudgeList,
  showPaperList,
  createExamData,
  editExamData,
} from "@/utils/apis";
export default {
  // watch: {
  //   "ruleForm.examRoom"(newVAL, oldVal) {
  //   },
  // },
  data() {
    return {
      Pages: {
        currentPageNum: 1,
        eachPageNum: 10,
        total: 0,
      },
      examRoomList: [], //选择考场数据
      allStudentList: [],
      studentTitle: "",
      studentDialogVisible: false,
      studentCategoryList: [], //学生分类列表
      studentSelect: "全部", //选择学生下拉框数据
      studentChecked: [], //学生多选框数据
      studentTable: [], //学生多选框列表数据
      paperTitle: "",
      paperDialogVisible: false,
      paperRadio: 1, //试卷类型单选框组
      paperValue: void 0, //试卷类型
      paperCategory: "", //考试形式
      paperRadioItem: 3, //考试试卷
      paperExam: "", //选择试卷考试数据
      options: [
        {
          id: 1,
          value: "选项1",
          label: "四级",
        },
        {
          id: 2,
          value: "选项2",
          label: "三级",
        },
        {
          id: 3,
          value: "选项3",
          label: "二级",
        },
        {
          id: 4,
          value: "选项4",
          label: "一级",
        },
      ], //试卷类型下拉框数据
      paperOptions: [
        {
          id: 1,
          value: "选项1",
          label: "理论考试",
        },
        {
          id: 2,
          value: "选项2",
          label: "实操考试",
        },
        {
          id: 3,
          value: "选项3",
          label: "理论实操",
        },
      ], //考试形式下拉框数据
      changePaper: [], //考试试卷下拉框数据
      singleQuestions: "", //单选题
      singleQuestionsScore: "", //单选题分数
      multipleQuestions: "", //多选题
      multipleQuestionsScore: "", //多选题分数
      judgmentQuestion: "", //判断题
      judgmentQuestionScore: "", //判断题分数
      operationOne: "", //商品信息采处理
      operationTwo: "", //网店开设
      operationThree: "", //网店管理
      operationFour: "", //网店推广

      judgeTitle: "",
      judgeDialogVisible: false,
      judgeChecked: [], //选择评委多选框数据
      judgeTable: [], //评委多选框列表数据
      rules: {
        examRoom: [
          { required: true, message: "请选择考场", trigger: "change" },
        ],
        examName: [
          { required: true, message: "请输入考场名称", trigger: "blur" },
        ],
        time: [
          {
            required: true,
            message: "请选择考试时间",
            trigger: "blur",
          },
        ],
      },
      studentList: [], //学生列表
      paperList: [], //试卷列表
      judgeList: [], //评委列表
      ruleForm: {
        id: "", //更新
        examName: "", //考试名称
        startTime: "", //开始时间
        endTime: "", //结束时间
        examRoom: "", //考场
        studentData: "", //选择考生
        paperData: "", //选择试卷
        judgeData: "", //选择评委
      },
      questionLow: "", //难度系数低
      questionHigh: "", //难度系数高
      questionType: void 0, //鉴定点题型是否相同
    };
  },
  mounted() {
    this.ruleForm.id = this.$route.query.id;
    this.showPaperListData();
    this.showExamRoom();
    this.showStudentList();
    this.showJudgeListData();
    // 如果有传入id代表编辑，执行这块方法
    if (this.$route.query.id) {
      this.editExamDataList();
    }
  },
  created() {},
  methods: {
    // 选择考场后直接将数据显示到学生列表中
    // showStudnetInexamRoom() {
    //   let params = {
    //     examination_room_id: this.ruleForm.examRoom,
    //     paging: 0,
    //     // page: this.Pages.currentPageNum,
    //     // limit: this.Pages.eachPageNum,
    //   };
    //   showExamStudentList(params).then((res) => {
    //     if (res.code === 200) {
    //       console.log(res.data);
    //       let arr = [];
    //       let sindex = 0;
    //       res.data.forEach((item) => {
    //         let obj = {
    //           id: item.user_id,
    //           sid: (sindex += 1),
    //           name: item.nickname,
    //         };
    //         arr.push(obj);
    //       });
    //       this.Pages.total = res.data.total;
    //       this.studentList = arr;
    //       let idArr = [];
    //       this.studentList.forEach((item) => {
    //         idArr.push(item.id);
    //       });
    //       this.ruleForm.studentData = idArr.join("#");
    //       this.studentDialogVisible = false;
    //       // console.log(this.ruleForm.studentData)
    //       this.getStudentList();
    //     }
    //   });
    // },
    // getStudentList() {
    //   let params = {
    //     examination_room_id: this.ruleForm.examRoom,
    //   };
    //   if (this.$route.query.id) {
    //     params.id = this.$route.query.id;
    //   }
    //   showExamStudentList(params).then((res) => {
    //     if (res.code === 200) {
    //       this.studentTable = res.data;
    //       this.allStudentList = res.data;
    //       // this.studentChecked = res.data.map((item) => {
    //       //   return item.user_id;
    //       // });
    //     }
    //   });
    // },
    // 学生列表分页
    // CurrentChange(val) {
    //   let params = {
    //     examination_room_id: this.ruleForm.examRoom,
    //     paging: 0,
    //     page: val,
    //     limit: this.Pages.eachPageNum,
    //   };
    //   showExamStudentList(params).then((res) => {
    //     if (res.code === 200) {
    //       // console.log(res.data);
    //       let arr = [];
    //       let sindex = 0;
    //       res.data.list.forEach((item) => {
    //         let obj = {
    //           id: item.user_id,
    //           sid: (sindex += 1),
    //           name: item.nickname,
    //         };
    //         arr.push(obj);
    //       });
    //       this.Pages.total = res.data.total;
    //       this.studentList = arr;
    //       let idArr = [];
    //       this.studentList.forEach((item) => {
    //         idArr.push(item.id);
    //       });
    //       this.ruleForm.studentData = idArr.join("#");
    //       this.studentDialogVisible = false;
    //     }
    //   });
    // },
    // 显示选择考场数据

    showExamRoom() {
      showExaminatinRoom().then((res) => {
        this.examRoomList = res.data;
      });
    },
    // 显示学生列表全部标识
    showStudentList() {
      examStudentList().then((res) => {
        if (res.code === 200) {
          this.studentCategoryList = res.data;

          let obj = {
            id: "全部",
            name: "全部",
          };

          this.studentCategoryList.unshift(obj);
        }
      });
    },
    // 显示评委列表
    showJudgeListData() {
      showExamJudgeList().then((res) => {
        if (res.code === 200) {
          this.judgeTable = res.data;
        }
      });
    },
    // 显示考试试卷下拉框数据
    showPaperListData() {
      let params = {
        exam_type: this.paperValue,
      };
      showPaperList(params).then((res) => {
        if (res.code === 200) {
          this.changePaper = res.data;
        }
      });
    },
    // 根据学生下拉框显示学生列表
    selectStudentList() {
      if (
        this.ruleForm.examRoom &&
        this.studentSelect &&
        this.ruleForm.startTime &&
        this.ruleForm.endTime
      ) {
        let params = {
          examination_room_id: this.ruleForm.examRoom,
          start_time: JSON.stringify(
            new Date(this.ruleForm.startTime).getTime()
          ).substring(0, 10),
          end_time: JSON.stringify(
            new Date(this.ruleForm.endTime).getTime()
          ).substring(0, 10),
        };
        if (this.studentSelect != "全部") {
          params.category_id = this.studentSelect;
        }
        showExamStudentList(params).then((res) => {
          if (res.code == 200) {
            this.studentTable = res.data;
            if (this.studentSelect == "全部") {
              this.allStudentList = res.data;
            }
          }
        });
      }
    },
    // 显示学生数据会话框
    changeStudent() {
      this.studentTitle = "选择学生";
      this.studentDialogVisible = true;
      // this.getStudentList()
    },
    // 显示试卷数据会话框
    changePapers() {
      this.paperTitle = "选择试卷";
      this.paperDialogVisible = true;
    },
    // 显示评委数据会话框
    changeJudge() {
      this.judgeTitle = "选择评委";
      this.judgeDialogVisible = true;
    },
    // 点击确定添加数据到学生列表中
    studentConfirmForm() {
      // let arr = [];
      let sindex = 1;
      // this.studentChecked.forEach((item) => {
      //   this.allStudentList.forEach((sitem) => {
      //     if (item == sitem.user_id) {
      //       let obj = {
      //         id: item,
      //         name: sitem.nickname,
      //         sid: (sindex += 1),
      //       };
      //       arr.push(obj);
      //     }
      //   });
      // });
      let arr = this.allStudentList.reduce((acc, cur) => {
        if (this.studentChecked.includes(cur.user_id)) {
          acc.push({
            id: cur.user_id,
            name: cur.nickname,
            sid: sindex++,
          });
        }
        return acc;
      }, []);
      this.studentList = arr;
      // 获取学生列表长度
      let len = arr.length;
      // 将长度复制给总条数，重新显示列表页
      this.Pages.total = len;
      // let idArr = [];
      // this.studentList.forEach((item) => {
      //   idArr.push(item.id);
      // });
      this.ruleForm.studentData = this.studentList
        .map((item) => item.id)
        .join("#");
      this.studentDialogVisible = false;
    },
    // 点击确定添加数据到试卷列表中
    paperconfirmForm() {
      // let arr = [];
      let pindex = 1;
      // this.changePaper.forEach((item) => {
      //   this.paperExam;
      //   if (this.paperExam == item.id) {
      //     let obj = {
      //       id: this.paperExam,
      //       name: item.name,
      //       pid: (pindex += 1),
      //     };
      //     arr.push(obj);
      //   }
      // });
      let arr = this.changePaper.reduce((acc, cur) => {
        if (cur.id == this.paperExam) {
          acc.push({
            id: this.paperExam,
            name: cur.name,
            pid: pindex++,
          });
        }
        return acc;
      }, []);
      this.paperList = arr;
      // let idArr = [];
      // this.paperList.forEach((item) => {
      //   idArr.push(item.id);
      // });
      this.ruleForm.paperData = this.paperList.map((item) => item.id).join("#");
      this.paperDialogVisible = false;
    },
    // 点击确定添加数据到评委列表中
    judgeConfirmForm() {
      // let arr = [];
      let index = 0;
      // this.judgeChecked.forEach((item) => {
      //   this.judgeTable.forEach((jitem) => {
      //     if (item == jitem.id) {
      //       let obj = {
      //         id: item,
      //         name: jitem.nickname,
      //         jid: (index += 1),
      //       };
      //       arr.push(obj);
      //     }
      //   });
      // });
      let arr = this.judgeTable.reduce((acc, cur) => {
        if (this.judgeChecked.includes(cur.id)) {
          acc.push({
            id: cur.id,
            name: cur.nickname,
            jid: index++,
          });
        }
        return acc;
      }, []);
      this.judgeList = arr;
      // let idArr = [];
      // this.judgeList.forEach((item) => {
      //   idArr.push(item.id);
      // });
      this.ruleForm.judgeData = this.judgeList.map((item) => item.id).join("#");

      this.judgeDialogVisible = false;
    },

    // 删除学生列表某一项
    deleteStudentItem(row) {
      this.$confirm(`是否删除，删除将无法恢复`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "green-message-box",
        type: "warning",
      })
        .then(() => {
          this.studentList.forEach((item, index) => {
            if (item.id === row.id) {
              this.studentList.splice(index, 1);
            }

            // 外面表格删除后，会话框的数据去掉勾选
            this.studentChecked.forEach((sitem, sindex) => {
              if (row.id === sitem) {
                this.studentChecked.splice(sindex, 1);
              }
            });
            let idArr = [];
            this.studentList.forEach((item) => {
              idArr.push(item.id);
            });
            this.ruleForm.studentData = idArr.join("#");
          });
          // 获取学生列表长度
          // let len = this.studentList.length;
          // console.log(len);
          // this.Pages.total = this.studentList.length
          // if ((len-1) % this.Pages.eachPageNum === 0) {
          //   this.Pages.currentPageNum = this.Pages.currentPageNum - 1;

          // }

          // let sindex = 0;
          //   let arr = this.allStudentList.reduce((acc, cur) => {
          //     if (this.studentChecked.includes(cur.user_id)) {
          //       acc.push({
          //         id: cur.user_id,
          //         name: cur.nickname,
          //         sid: sindex++,
          //       });
          //     }
          //     return acc;
          //   }, []);
          //   this.studentList = arr;

          //   this.Pages.total = arr.length;
          //   this.Pages.total = this.studentList.length
          // if ((len-1) % this.Pages.eachPageNum === 0) {
          //   this.Pages.currentPageNum = this.Pages.currentPageNum - 1;

          // }
          // let arr = [];

          // 将长度复制给总条数，重新显示列表页
          // this.Pages.total = len;
          // this.Pages.eachPageNum = len / this.Pages.currentPageNum;
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 删除评委列表某一项
    deleteJudgeItem(row) {
      this.$confirm(`是否删除，删除将无法恢复`, "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "green-message-box",
        type: "warning",
      })
        .then(() => {
          this.judgeList.forEach((item, index) => {
            if (item.id === row.id) {
              this.judgeList.splice(index, 1);
            }
          });
          this.judgeChecked.forEach((jitem, jindex) => {
            if (row.id === jitem) {
              this.judgeChecked.splice(jindex, 1);
            }
          });
          let idArr = [];
          this.judgeList.forEach((item) => {
            idArr.push(item.id);
          });
          this.ruleForm.judgeData = idArr.join("#");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 创建考试
    confirmForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            examination_room_id: this.ruleForm.examRoom,
            exam_type: this.paperValue,
            exam_form: this.paperCategory,
            student: this.ruleForm.studentData,
            type: this.paperRadioItem,
            paper_id: this.ruleForm.paperData,
            judge: this.ruleForm.judgeData,
            start_time: JSON.stringify(
              new Date(this.ruleForm.startTime).getTime()
            ).substring(0, 10),
            end_time: JSON.stringify(
              new Date(this.ruleForm.endTime).getTime()
            ).substring(0, 10),
            exam_name: this.ruleForm.examName,
            // student_category: this.studentSelect,
          };
          if (this.ruleForm.id) {
            params.id = this.ruleForm.id;
          }
          createExamData(params)
            .then((res) => {
              if (res.code === 200) {
                this.$message({
                  type: "success",
                  message: res.msg,
                });
                this.$router.push({
                  path: "/examManage/create",
                });
              }
            })
            .catch((err) => {
              console.log("err", err);
            });
        } else {
          return false;
        }
      });
    },

    // 编辑考试
    editExamDataList() {
      let params = {
        id: this.$route.query.id,
      };
      editExamData(params).then((res) => {
        if (res.code === 200) {
          // console.log(res.data);
          this.ruleForm.examName = res.data.examination_info.exam_name;
          this.ruleForm.startTime = res.data.examination_info.start_time;
          this.ruleForm.endTime = res.data.examination_info.end_time;
          this.ruleForm.examRoom =
            res.data.examination_info.examination_room_id;
          this.paperValue = res.data.examination_info.exam_type;
          this.paperCategory = res.data.examination_info.exam_form;
          this.paperRadioItem = res.data.examination_info.type;
          // 遍历考试考卷到考试列表
          let pindex = 0;
          this.changePaper.forEach((Citem) => {
            if (res.data.examination_info.paper_id == Citem.id) {
              this.paperExam = Citem.id;
              let obj = {
                id: Citem.id,
                name: Citem.name,
                pid: (pindex += 1),
              };
              this.paperList.push(obj);
            }
          });

          this.ruleForm.paperData = this.paperList
            .map((item) => item.id)
            .join("#");

          // 将评委数据回显到评委列表
          this.judgeList = [];
          this.judgeChecked = [];
          let jindex = 0;
          res.data.judge.forEach((Jitem) => {
            this.judgeChecked.push(Jitem.judge_id);
            let obj = {
              id: Jitem.judge_id,
              name: Jitem.nickname,
              jid: (jindex += 1),
            };
            this.judgeList.push(obj);
          });
          // let JudgeidArr = [];
          // this.judgeList.forEach((JLitem) => {
          //   JudgeidArr.push(JLitem.id);
          // });
          this.ruleForm.judgeData = this.judgeList
            .map((item) => item.id)
            .join("#");

          // 遍历数据到学生列表
          this.studentList = [];
          this.studentChecked = [];
          let sindex = 0;
          res.data.student.forEach((sitem) => {
            this.studentChecked.push(sitem.student_id);
            let obj = {
              id: sitem.student_id,
              name: sitem.nickname,
              sid: (sindex += 1),
            };
            this.studentList.push(obj);
          });
          this.selectStudentList();
          // let SidArr = [];
          // this.studentList.forEach((item) => {
          //   SidArr.push(item.id);
          // });
          this.ruleForm.studentData = this.studentList
            .map((item) => item.id)
            .join("#");
        }
      });
      this.$forceUpdate();
    },

    // 取消
    cancelExam() {
      this.$router.push({
        path: "/examManage/create",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  /*滚动条整体样式*/
  display: none;
}
.create-exam {
  height: 100%;
  overflow-y: auto;
  padding: 11px 19px;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  .exam-hr {
    margin-top: 26px;
    border: none;
    border-bottom: 2px solid rgba(241, 245, 255, 1);
  }
  .exam-main {
    margin-top: 30px;
    .exam-title {
      display: flex;
      align-items: center;

      .green-block {
        width: 5px;
        height: 20px;
        background: #2dc079;
        border-radius: 3px;
        margin-right: 10px;
      }

      span {
        line-height: 1;

        &:first-of-type {
          font-size: 18px;
        }

        &:last-of-type {
          font-size: 16px;
          color: #999;
        }
      }
    }

    .exam-setting {
      margin: 41px 0 44px 0;
    }
    .change-btn {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }

    .student-table {
      margin: 15px 0 0 25px;
      border: 1px solid rgba(220, 220, 220, 1);
      width: 400px;
      height: 400px;
      overflow-y: auto;
      .student-check {
        display: flex;
        align-items: center;
        margin: 20px;
      }
    }

    .exam-time {
      position: relative;
      .exam-minute {
        position: absolute;
        right: -10%;
      }
    }

    .paper-category {
      margin-bottom: 20px;
    }

    .paper-select {
      margin-top: 25px;
      display: flex;
    }

    .paper-table {
      width: 100%;
      height: 990px;
      border: 1px solid rgba(220, 220, 220, 1);
    }

    .question-setting {
      display: flex;
      margin-left: 20px;
      margin-top: 33px;
    }

    .scope-question {
      margin-top: 33px;
    }

    .scope-table {
      margin: 30px 60px;
      border: 1px solid #dddfeb;
      border-collapse: collapse;
      border-radius: 4px;
      tr {
        border: none;
      }
      td {
        border: 1px solid #dddfeb;
        text-align: center;
      }
      .scope-table-header {
        border: 1px solid #dddfeb;
      }
    }
    // 表格
    .table-box {
      display: flex;
      position: relative;
      height: 430px;
      .table-left-1,
      .table-left-2,
      .table-left-3,
      .table-left-4,
      .table-left-5,
      .table-left-6,
      .table-left-7,
      .table-left-8,
      .table-left-9,
      .table-left-10,
      .table-right-1,
      .table-right-2,
      .table-right-3,
      .table-right-4,
      .table-right-5,
      .table-right-6,
      .table-right-7,
      .table-right-8 {
        border: 1px solid rgba(220, 220, 220, 1);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .table-left-1 {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: -30px;
        left: 4.6%;
        border-top: none;
        width: 126px;
        height: 440px;
      }

      .table-left-2 {
        border-left: none;
        border-top: none;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        width: 127px;
        height: 440px;
        top: -30px;
        left: 14.5%;
      }

      .table-left-3 {
        position: absolute;
        top: -30px;
        left: 24.3%;
        width: 127px;
        height: 215px;
        border-left: none;
        border-top: none;
      }
      .table-left-4 {
        border-left: none;
        border-top: none;
        position: absolute;
        top: -30px;
        left: 34.2%;
        // display: flex;
        width: 126px;
        height: 215px;
      }
      .table-left-5 {
        border-top: none;
        border-left: none;
        position: absolute;
        left: 21%;
        top: 185px;
        width: 170px;
        height: 225px;
      }
      .table-left-6 {
        border-top: none;
        border-left: none;
        position: absolute;
        left: 34%;
        top: 185px;
        width: 128px;
        height: 225px;
      }
      .table-left-7,
      .table-left-9,
      .table-left-8,
      .table-left-10 {
        border-top: none;
        border-left: none;
        position: absolute;
        width: 127px;
        height: 108.5px;
      }
      .table-left-7 {
        top: -30px;
        left: 44%;
      }
      .table-left-8 {
        top: -30px;
        left: 53.8%;
      }
      .table-left-9 {
        top: 77px;
        left: 44%;
      }
      .table-left-10 {
        top: 77px;
        left: 53.8%;
      }
      .table-right-1,
      .table-right-2 {
        border-top: none;
        border-left: none;
        position: absolute;
        width: 127px;
        height: 108.5px;
        top: 188px;
      }
      .table-right-1 {
        left: 44%;
      }
      .table-right-2 {
        left: 53.8%;
      }
      .table-right-3,
      .table-right-4 {
        border-top: none;
        border-left: none;
        position: absolute;
        width: 129px;
        height: 112.5px;
        top: 298px;
      }
      .table-right-3 {
        left: 43.8%;
      }
      .table-right-4 {
        left: 53.6%;
      }
      .table-right-5,
      .table-right-6,
      .table-right-7,
      .table-right-8 {
        border-top: none;
        border-left: none;
        position: absolute;
        width: 140px;
        height: 108.5px;
      }
      .table-right-5 {
        top: -30px;
        left: 63.7%;
      }
      .table-right-6 {
        top: 79px;
        left: 63.7%;
      }
      .table-right-7 {
        top: 190px;
        left: 63.7%;
      }
      .table-right-8 {
        top: 301px;
        left: 63.7%;
      }
    }

    .question-level {
      display: flex;
      margin: 15px 0 0 50px;
    }

    .question-type {
      margin: 15px 0 0 50px;
    }

    .dialog-footer {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>